/**
 * Склеивает имена классов, отбрасывая пустые значения.
 *
 * Своя реализация вместо зависимости: нужна ровно эта строчка, а любая
 * библиотека для того же самого — лишний пакет в сопровождении.
 */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(' ');
}
